module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-left": "0px"
    }
  }, [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("device-embedded-detail")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'container ' + _vm.pageContainerSize
  }, [_c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "width": "100%",
      "height": "100px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: " col-xs-6"
  }, _vm._l((_vm.formFields.col1), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, _vm._l((_vm.formFields.col2), function(f) {
    return _c('field-box', {
      key: f.id,
      attrs: {
        "data": f,
        "read": _vm.readOnly,
        "val": _vm.values[f.id]
      }
    })
  })), _vm._v(" "), (_vm.hideNewBtn == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "232px",
      "float": "right",
      "margin-right": "5px",
      "background": "#43c9de",
      "border-color": "#43c9de"
    },
    attrs: {
      "disabled": _vm.selected_row == Number.MAX_SAFE_INTEGER || _vm.disableNewBtn == true || _vm.read_only == false || _vm.checkUserPermission(true, _vm.permissionMode.ADD) == false
    },
    on: {
      "click": _vm.addNew
    }
  }, [_vm._v("新規（組込情報）")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdminSavingApplication == true),
      expression: "isAdminSavingApplication == true"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "108px",
      "float": "right",
      "margin-right": "10px",
      "background": "#43c9de",
      "border-color": "#43c9de"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onSubTableDeviceEmbeddedInformationAddCheckConfirmdri
    }
  }, [_vm._v("上書登録")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdminSavingApplication == false && _vm.approvalMode == false),
      expression: "isAdminSavingApplication == false && approvalMode == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "108px",
      "float": "right",
      "margin-right": "10px",
      "background": "#43c9de",
      "border-color": "#43c9de"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onLocalSaveSubDevEmbedded
    }
  }, [_vm._v("下書登録")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isAdminSavingApplication == false && _vm.approvalMode == true),
      expression: "isAdminSavingApplication == false && approvalMode == true"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "108px",
      "float": "right",
      "margin-right": "10px",
      "background": "#43c9de",
      "border-color": "#43c9de"
    },
    attrs: {
      "disabled": _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onLocalSaveSubDevEmbeddedOnApprove
    }
  }, [_vm._v("上書保存")]) : _vm._e(), _vm._v(" "), (_vm.read_only == false) ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "109px",
      "float": "right",
      "margin-right": "10px",
      "background": "#A6A6A6",
      "border-color": "#A6A6A6"
    },
    attrs: {
      "disabled": _vm.disableCancel
    },
    on: {
      "click": _vm.btnCancel
    }
  }, [_vm._v("キャンセル")]) : _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideEditBtn == false),
      expression: "hideEditBtn == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "227px",
      "float": "right",
      "margin-right": "10px",
      "background": "#43c9de",
      "border-color": "#43c9de"
    },
    attrs: {
      "disabled": _vm.selected_row == -1 || _vm.disableEditBtn == true || _vm.checkUserPermission(true, _vm.permissionMode.EDIT) == false
    },
    on: {
      "click": _vm.onEdit
    }
  }, [_vm._v("編集（組込情報）")]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hideEditBtn == false),
      expression: "hideEditBtn == false"
    }],
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "100px",
      "width": "240px",
      "float": "right",
      "margin-right": "7px",
      "background": "#ed791a",
      "border-color": "#ed791a"
    },
    attrs: {
      "disabled": _vm.disableDelete || _vm.checkUserPermission(true, _vm.permissionMode.DELETE) == false
    },
    on: {
      "click": _vm.onDelete
    }
  }, [_vm._v(_vm._s(_vm.deleteText))])]), _vm._v(" "), _c('confirmation-modal-device-link', {
    attrs: {
      "tag": "showConfimationModalSetYobiki"
    },
    on: {
      "done": _vm.confirmedSetYobiki
    }
  }), _vm._v(" "), _c('yobiki-modal', {
    attrs: {
      "tag": "showYobikiModal"
    },
    on: {
      "selected": _vm.onYobikiModalSelected
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "deleteDeiveEmbeddedDetailModal"
    },
    on: {
      "done": _vm.onConfirmDelete
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "notificationAfterSaveDetails"
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmSubDeviceEmbeddedInformationAddCheck"
    },
    on: {
      "done": _vm.onSubTableDeviceEmbeddedInformationAddCheckConfirm
    }
  }), _vm._v(" "), _c('confirmation-modal', {
    attrs: {
      "tag": "confirmSubDeviceEmbeddedInformationAddCheckOnApprove"
    },
    on: {
      "done": _vm.onSubTableDeviceEmbeddedInformationAddCheckConfirmOnApprove
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21ef51f7","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sub_pages/device-embedded-detail.vue
// module id = 945
// module chunks = 0